/**
 * Format a monetary value with the given currency object.
 *
 * @param {number} value
 * @param {{ symbol?: string } | null | undefined} currency
 * @param {number} decimals - decimal places (default 0)
 */
export function fmt(value, currency, decimals = 0) {
  const symbol = currency?.symbol ?? "€";
  if (value == null || isNaN(value)) return `${symbol} 0`;
  const abs = Math.abs(value);
  const str = abs.toLocaleString("nl-BE", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  return value < 0 ? `-${symbol} ${str}` : `${symbol} ${str}`;
}
